export class DataExternalSetting {
  idArea: number;
  idExternalContent: number;
  constructor(idArea, idExternalContent) {
    this.idArea = idArea;
    this.idExternalContent = idExternalContent;
  }
}
